import { createEntityAdapter } from "@reduxjs/toolkit";
import { User } from "./dataTypes";

export const userAdapter = createEntityAdapter<User>({});
